import useToaster from "./useToaster";

export default function useClips() {
  const { addToaster } = useToaster();
  const baseUrl = process.env.REACT_APP_API_URL || "";
  const url = `${baseUrl}/api/clips`;

  const safeFetch = async (endpoint, options = {}) => {
    try {
      const token = localStorage.getItem("x-token");
      const headers = { "Content-Type": "application/json" };
      headers["Authorization"] = `Bearer ${token}`;

      const response = await fetch(endpoint, { ...options, headers });

      if (response.status === 401) {
        window.dispatchEvent(new Event("auth-logout"));
        throw new Error("Session expired — please log in again");
      }
      let data = null;
      try {
        data = await response.json();
      } catch {
        if (!response.ok) throw new Error(`Request failed (${response.status})`);
      }
      if (!response.ok) {
        throw new Error(data?.message || `Request failed (${response.status})`);
      }
      return data;
    } catch (error) {
      addToaster({
        message: `${error?.message || JSON.stringify(error)}`,
        severity: "error",
      });
      throw error;
    }
  };

  const listShows = (days) =>
    safeFetch(`${url}/shows${days ? `?days=${days}` : ""}`);

  const generateFromClip = ({ key, startSec, endSec }) =>
    safeFetch(`${url}/generate`, {
      method: "POST",
      body: JSON.stringify({ key, startSec, endSec }),
    });

  return { listShows, generateFromClip };
}
